<template>
  <div v-role="'func'">
    <div class="formPosition">
      <v-card width="1200" class="mx-auto">
        <!-- Header with title and action button -->
        <v-card-title class="primary white--text d-flex justify-space-between align-center">
          <div class="d-flex align-center">
            <v-icon class="mr-2" color="white">account_balance</v-icon>
            <h2 class="headline">Contas Bancárias</h2>
          </div>
          <v-btn to="Novo-banco" color="white" outlined>
            <v-icon left>add</v-icon>
            Registrar Conta
          </v-btn>
        </v-card-title>

        <!-- Loading overlay -->
        <v-overlay :value="progresso">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <!-- Search section -->
        <v-card-text>
          <v-row class="mb-4" align="center">
            <v-col cols="12" sm="6" class="py-0">
              <v-text-field
                v-model="search"
                append-icon="search"
                placeholder="Pesquisar por banco ou número de conta"
                outlined
                dense
                hide-details
                clearable
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- Data table -->
          <v-data-table
            :search="search"
            :headers="headers"
            :items="produtos"
            :loading="progresso"
            loading-text="Carregando contas bancárias..."
            no-data-text="Nenhuma conta bancária encontrada"
            class="elevation-1"
          >
            <template v-slot:item.indice="{ item }">
              <span>{{ produtos.indexOf(item) + 1 }}</span>
            </template>
            
          </v-data-table>
        </v-card-text>

        <!-- Details dialog -->
        <v-dialog v-model="dialog_detalhes" max-width="1000px" persistent>
          <v-card>
            <v-card-title class="primary white--text">
              <v-icon left color="white">info</v-icon>
              <span class="headline">Detalhes da Conta Bancária</span>
            </v-card-title>
            <v-card-text>
              <v-container></v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" class="white--text" @click="dialog_detalhes = false">
                <v-icon left>close</v-icon>
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import axios from '../../plugins/axios';

export default {
  data: () => ({
    produtos: [],
    progresso: false,
    dialog_detalhes: false,
    search: '',
    headers: [
      { text: '#', value: 'indice' },
      { text: 'Conta', value: 'descricao' },
      { text: 'Número de Conta', value: 'numeroConta'},
      { text: 'Banco', value: 'nome'},
      { text: 'Sigla', value: 'sigla'},
      { text: 'Data de Cadastro', value: 'data_' },
      { text: 'Registrado por', value: 'autor_'},
    ]
  }),

  created() {
    this.InitializeContasBancarias();
  },

  methods: {
    async InitializeContasBancarias() {
      this.progresso = true;
      try {
        this.produtos = await axios.get('/conta-bancariaFindAll-escola').then(res => res.data);
      } catch (error) {
        Swal.fire('Erro', 'Não foi possível carregar as contas bancárias', 'error');
      } finally {
        this.progresso = false;
      }
    }
  }
};
</script>

<style scoped>
.formPosition {
  padding: 20px;
}

.primary {
  background-color: #006699 !important;
}

.v-card {
  border-radius: 8px;
  overflow: hidden;
}

.v-data-table {
  margin-top: 16px;
}

.headline {
  font-size: 1.5rem;
  font-weight: 500;
}
</style>